export default __webpack_public_path__ + "static/media/reports.dcf4f1b7.svg";